// extracted by mini-css-extract-plugin
export var content = "_63-3";
export var list = "_63-4";
export var settingsContent = "_63-7";
export var settingsPanel = "_63-8";
export var state = "_63-6";
export var triggerBadge = "_63-2";
export var triggerButton = "_63-1";
export var triggerShell = "_63-0";
export var unreadDot = "_63-5";